/* eslint-disable */
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import React, { useState } from 'react';
import { styled, SxProps, Theme } from '@mui/material/styles';
import { InputLabel, Stack, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import {
  BaseSingleInputFieldProps,
  DateValidationError,
  FieldSection,
} from '@mui/x-date-pickers/models';
import { CalendarPickerIcon } from '../../../icons';
import { CommonElementProps } from '../types';
import { twMerge } from 'tailwind-merge';
import ElementUtils from '../utils';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import theme from '../../../theme';

export type DateValue = moment.Moment | null | undefined;
export interface DatePickerProps extends CommonElementProps<DateValue> {
  value?: DateValue;
  onChange?: (value: moment.Moment | null) => void;
  label?: string;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  isNavRequired?: boolean;
  disableFutureDates?: boolean;
}
const IconButtonStyle: SxProps<Theme> = {
  borderRadius: '5px',
  '.MuiTouchRipple-ripple .MuiTouchRipple-child': {
    borderRadius: '5px',
    backgroundColor: 'red'
  },
  '&:hover': {
    opacity: 0.7,
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
};

interface ButtonFieldProps
  extends UseDateFieldProps<moment.Moment>,
  BaseSingleInputFieldProps<moment.Moment | null, FieldSection, DateValidationError> {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  error?: boolean;
  label?: any;
  value?: DateValue;
}
function ButtonField(props: ButtonFieldProps) {
  const {
    setOpen,
    // controlledValue,
    label,
    error,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
    value,
  } = props;
  const start = value ? moment(value) : null;

  const formatted = value ? `${start?.format('MMM DD, YYYY')}` : "Select Date";

  return (
    <Button
      // variant="outlined"
      color="secondary"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
      startIcon={<CalendarPickerIcon />}
      className={twMerge('w-[275px] justify-start custom-shadow', error && 'outline outline-[1px] outline-error')}
    >
      <div className='justify-center w-full'>{formatted}</div>
    </Button>
  );
}

const CustomDatePicker = function CustomDatePicker(props: DatePickerProps) {
  const {
    value: defaultValue,
    onChange,
    label,
    error,
    minDate,
    disabled,
    maxDate,
    isNavRequired,
    disableFutureDates
  } = props;
  const [value, setValue] = React.useState<DateValue>(null);
  const [dateOpen, setOpen] = useState(false);

  React.useEffect(() => {
    setValue(defaultValue ? moment(defaultValue) : null);
  }, [defaultValue]);

  const handleDateChange = (newValue: moment.Moment | null) => {
    if (onChange) {
      onChange(newValue);
    } else {
      setValue(newValue);
    }
  };

  const handleDateClose = () => {
    setOpen(false);
  };

  const goToPreviousDate = () => {
    if (!value) return;
    const previous = value.subtract(1, 'days');
    handleDateChange(previous);
  }

  const goToNextDate = () => {
    if (!value) return;
    const next = value.add(1, 'days');
    handleDateChange(next);
  }



  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack direction="column" justifyContent="flex-start" className="text-left relative">
        <InputLabel error={Boolean(error)} className="text-[14px] font-semibold mb-1 text-[#28364C]">{label}</InputLabel>
        <Stack direction="row" gap={2} alignItems="space-between">
          <DatePicker
            value={value ? moment(value) : null}
            open={dateOpen}
            onChange={handleDateChange}
            onClose={handleDateClose}
            disableHighlightToday
            disableFuture={disableFutureDates}
            disabled={disabled}
            minDate={minDate ? moment(minDate) : undefined}
            maxDate={maxDate ? moment(maxDate) : undefined}
            // label="Week picker"
            showDaysOutsideCurrentMonth
            slots={{ field: ButtonField }}
            slotProps={{
              // day: {
              //   selectedDay: value,
              // } as any,
              field: { value, label, setOpen, error: Boolean(error) } as any,
            }}
          />
          {isNavRequired && <Stack direction="row" gap={2} alignItems="space-between">
            <IconButton onClick={goToPreviousDate} sx={IconButtonStyle}><IoIosArrowBack /></IconButton>
            <IconButton disabled={value?.date() === moment().date()} onClick={goToNextDate} sx={IconButtonStyle}><IoIosArrowForward /></IconButton>
          </Stack>}
        </Stack>
        {error && (
          <div className="absolute -bottom-5 text-error text-xs">
            {ElementUtils.renderError(error)}
          </div>
        )}
      </Stack>
    </LocalizationProvider>
  );
};

CustomDatePicker.defaultProps = {
  onChange: () => { },
  isNavRequired: false,
  disableFutureDates: false,
};

CustomDatePicker.propTypes = {

};
export default CustomDatePicker;
